import { getFlowConfig, getFlowSteps } from '../../flow-initial/getFlowConfig';
import { setFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
import { getIsMobile } from '../../utils/deviceUtils';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
export const BranchACQ142VariantA = {
  name: 'BranchACQ142VariantA',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0142, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const flowConfig = getFlowConfig();

    if (flowConfig) {
      flowConfig.shouldUseWaveOnPostAccountCreation = false;
    }

    const {
      preVerification,
      postExistingAccountSelection
    } = getFlowSteps();
    const postVerificationSteps = [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain, Step.HubletSelection];
    const postAccountCreationSteps = [Step.ProductExperience, Step.ProblemAwareness, Step.Industry, Step.CompanySize, Step.ManagementLevel, Step.UseCase, Step.AhaMoment, ...(getIsMobile() ? [Step.MobileAppPrompt] : [])];
    const nextSteps = [...(isPreVerification() ? preVerification : []), ...postVerificationSteps, ...postAccountCreationSteps];
    dispatch(setFlow(nextSteps, preVerification, postVerificationSteps, postAccountCreationSteps, postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.LandingPage,
  afterData: null,
  afterStep: null
};